export default __webpack_public_path__ + "media/images/mail/facebook-03e5e20d763b31b79eb1012cb7dc157c.png";